<template>
  <div ref="intersectionWrapperRef">
    <slot v-if="intersectionHappened"></slot>
  </div>
</template>

<script lang="ts" setup>
const intersectionHappened = ref(false)
const intersectionWrapperRef = ref<HTMLDivElement | undefined>(undefined)

onMounted(() => {
  if (
    !('IntersectionObserver' in window) ||
    !('IntersectionObserverEntry' in window) ||
    !('intersectionRatio' in window.IntersectionObserverEntry.prototype)
  ) {
    intersectionHappened.value = true
    return
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          intersectionHappened.value = true
        }
      })
    },
    {
      threshold: 0.5,
    }
  )

  if (intersectionWrapperRef.value) {
    observer.observe(intersectionWrapperRef.value)
  }
})
</script>
